import React from "react";
import PushPinIcon from '@mui/icons-material/PushPin';

function Header() {
  return (
    <header>
      <h1><PushPinIcon />Keeper</h1>
    </header>
  );
}

export default Header;
